import { useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';

export function useSalesAgentsUnavailable(): boolean {
  const { billing } = useEnv();
  return billing.sales_agents_allowed === 0;
}
